const DEFAULT_MAX = 250

export const pixelToPercent = (
  pixel: number,
  max: number = DEFAULT_MAX
): number => Math.round((pixel / max) * 100)

export const percentToPixel = (
  percent: number,
  max: number = DEFAULT_MAX
): number => Math.round((percent * max) / 100)
